export default {
  // 日历汇总
  selectYhMachineMonthSum: "/business/yhMachineTeam/selectYhMachineMonthSum",
  // 查询机械台班详情
  selectYhMachineTeamByMachineTeamId: "/business/yhMachineTeam/selectYhMachineTeamByMachineTeamId",
  // 统计机械台班详情
  selectYhMachineTeamStat: "/business/yhMachineTeam/selectYhMachineTeamStat"
};
